
import { Component, Emit, Prop, Vue } from "nuxt-property-decorator";

export type AccordionToggleEvent = {
  value: string;
};

@Component({
  components: {},
})
export default class Accordion extends Vue {
  @Prop({ required: true }) readonly value: string;

  expanded = false;

  @Emit()
  toggleExpandedState(): AccordionToggleEvent {
    return { value: this.value };
  }
}
